import { Checkbox as NextCheckbox } from "@heroui/react";
import { withFormComponent } from "./hoc"

export const Checkbox = withFormComponent(NextCheckbox);